export const SERVER_URL = "http://3.127.121.159:3000";
